import { CommonNotificationService } from './../../../services/common-notification/common-notification.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ClipboardService } from 'ngx-clipboard';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-shared-table',
  templateUrl: './shared-table.component.html',
  styleUrls: ['./shared-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SharedTableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() displayedColumns: any;
  @Input() dataSource: any;
  @Input() metaData: any;
  @Input() isNudgeJourney?: boolean;
  tableDataSource: any;
  expandedElement: any | null = null;

  constructor(
    private clipboardService: ClipboardService,
    private commonNotificationService: CommonNotificationService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() { }

  ngOnChanges() {
    this.tableDataSource = new MatTableDataSource(this.dataSource);
  }

  splitText(text) {
    const splitByComma = text.split(',').join(',\n').split('{').join('{\n\t').split('}').join('\n}').split(' ').join('\t');
    const textShow = `${splitByComma}`;
    return textShow;
  }

  getCapitalizedValue(string) {
    const splitBySpace = string.split(' ').map(val => val.charAt(0).toUpperCase() + val.slice(1)).join(' ');
    const splitByUnderscore = splitBySpace.split('_').map(val => val.charAt(0) + val.slice(1)).join(' ');

    return splitByUnderscore;
  }

  handleSortableIconClick = () => {
    // first update the arrow status then call the sortable fn
    this.metaData.status.iconCallbackFn();
    this.metaData.status.callbackFn();
  }

  handlePageChange(event) {
    this.metaData.paginator.pageSize = event.pageSize;
    if (this.metaData.paginator.hasOwnProperty('pageIndex')) {
      this.metaData.paginator.pageIndex = event.pageIndex;
    }
    this.metaData.searchQuery ? this.metaData.searchQueryCallbackFn(this.metaData.searchQuery, event.pageIndex) : this.metaData.paginator.pageCallbackFn(true, event.pageIndex);
  }

  getProgressBarStyle() {
    const styleObj: any = {
      top: 0,
      width: '100%'
    };
    const header = document.querySelector('.hsl-shared-table-header');
    const table = document.querySelector('.table-container');
    if (!header || !table) {
      styleObj['top'] = '240px';
      return styleObj;
    }

    const headerBoundingRect = header.getBoundingClientRect();
    const tableBoundingRect = table.getBoundingClientRect();
    styleObj['top'] = `${headerBoundingRect.height + headerBoundingRect.top}px`;
    styleObj['width'] = `${tableBoundingRect.width}px`;
    return styleObj;
  }

  getHeaderStyle(colIndex) {
    let width: string = '';
    if (this.metaData['isActivityLogsPage']) {
      width = colIndex === 0 ? '22%' : colIndex === 1 ? '27%' : colIndex === 2 ? '30%' : colIndex === 3 ? '18%' : '';
    }
    else if (this.metaData['isJourneyListPage']) {
      width = colIndex === 0 ? '10%' : colIndex === 1 ? '6%' : colIndex === 2 ? '30%' : '';
    }
    else if (!this.metaData['isJourneyListPage']) {
      width = colIndex === 0 ? '25%' : colIndex === 1 ? '27%' : colIndex === 2 || colIndex === 3 ? '18%' : '';
    }
    return { 'width': width };
  }

  copyClipBoard(data) {
    data = JSON.stringify(data);
    this.clipboardService.copyFromContent(data);
    this.commonNotificationService.showSnackBar(`Metadata Copied`, 'success', 2000);
  }

  copyLink(text) {
    this.clipboardService.copyFromContent(text);
    this.snackBar.open(`${text} copied to your clipboard`, '', {
      duration: 2000,
      verticalPosition: 'bottom',
      panelClass: ['black-snackbar']
    });
  }
}